import React, { FC, memo } from "react";

import { ExpandableTitle } from "../components/ExpandableTitle/ExpandableTitle";
import { ContainerChildren } from "../components/ContainerChildren/ContainerChildren";
import { Container } from "./styled";
import { ContainerProps } from "../types";

export const PagesContainer: FC<ContainerProps> = memo(({ config, elementConfig, type, renderElement }) => {
  const { options, children, style } = elementConfig || config || {};
  const { column } = options || {};
  const isColumn = column === undefined || column;

  return (
    <>
      <ExpandableTitle elementConfig={elementConfig} type={type} renderElement={renderElement} />
      <Container style={style} isColumn={isColumn} isMain>
        <ContainerChildren items={children} isMain renderElement={renderElement} />
      </Container>
    </>
  );
});
